import { Fade } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import FiltrosProcessosJudiciais from "./abaProcessosJudicias/FiltrosProcessosJudiciais";
import TabelaProcessosJudiciais from "./abaProcessosJudicias/TabelaProcessosJudiciais";
import ModalProcessosJudiciais from "./abaProcessosJudicias/ModalProcessosJudiciais";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";

export const TabProcessosJudiciais: React.FC = () => {
  const [mostrarConteudo, setMostrarConteudo] = useState<boolean>(false);
  const { showModalProcessosJudiciais, openCloseModalProcessosJudiciais } = useProcessosJudiciaisContext();

  useEffect(() => {
    setMostrarConteudo(true);
  }, []);

  return (
    <Container>
      <Fade in={mostrarConteudo} timeout={700}>
        <div>
          <FiltrosProcessosJudiciais />
          <TabelaProcessosJudiciais />
          <ModalProcessosJudiciais
            showModal={showModalProcessosJudiciais}
            onCloseModal={() => openCloseModalProcessosJudiciais()}
          />
        </div>
      </Fade>
    </Container>
  );
};
